import React, { Component } from 'react';
var classNames = require('classnames');

class DropdownRow extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      dropdownActive: false
    }
  }

  getById(eId){
    const selectedId = parseInt(eId, 16);
    return this.props.data.filter(item => item.id === selectedId)[0]
  }

  handleChange(e) {
    const selected = this.getById(e);
    this.props.onChange(selected);
    this.setState({
      dropdownActive: false
    })
  }

  toggleDropdown = () => {
    var activeBool = this.state.dropdownActive ? false : true;
    this.setState({
      dropdownActive: activeBool
    })
  }

  componentWillMount() {
    // set up first item in the list
    const preselected = this.props.preselect ? this.props.preselect : 0;
    this.props.onChange(this.props.data[preselected])
  }

  returnFootnoteText = (text) => {
    return(
      <p className={this.props.styles.footnotetext}>{text}</p>
    )
  }

  render() {
    const styles = this.props.styles;
    const data = this.props.data;
    const selectedItem = this.props.selected;
    const activeDropdownStyle = this.state.dropdownActive ? styles.dropdownChoicesActive : null;
    const listOptions = data.map((item) => {
      const activeClass = item.id === selectedItem.id ? styles.dropdownChoiceActive : null;
      return(
        <li key={item.id} className={activeClass} onClick={() => this.handleChange(item.id)}>{item.name}</li>
      );
    })
    const footnoteText = this.props.footnoteText ? this.returnFootnoteText(this.props.footnoteText) : null  
    return(
      <div className={styles.rowContainer}>
        <div className={styles.row}>
          <div className={styles.left}>
            <span className={classNames(styles.bottom, styles.bottomRow)}>{this.props.description}</span>
            {footnoteText}
          </div>
          <div className={styles.rightContainer} >
            <div className={styles.rightInput}>
              <div className={styles.dropdownContainer}>
                <button className={classNames(styles.dropdownButton, styles.dropdownButtonWidth)} onClick={() => this.toggleDropdown()}>{selectedItem.name}</button>
                <ul className={classNames([styles.dropdownChoices, activeDropdownStyle])}>
                  {listOptions}
                </ul>
              </div>
            </div>
            <div className={styles.rightInfo}>
              <span>{this.props.unitInfo}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DropdownRow;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_dropdown_row.js